<template>
  <div class="swhyjm-2021-index">
    <!---->
    <div class="scroll-div" style="height: calc(100% - 1.1rem)">
      <div class="swhyjm-2021-front" label="" loadmorecover="true">
        <div v-if="!activeRouter">
          <div class="front-header">
            <img src="../assets/img/m-banner.png" />
            <div class="header-tabs">
              <div
                class="header-tabs-item"
                @click="handleActiveRouter('rule', '赛事规则')"
              >
                <img src="../assets/img/m-icon-1.png" />
                <p>赛事规则</p>
              </div>
              <div
                class="header-tabs-item"
                @click="handleActiveRouter('award', '大赛奖励')"
              >
                <img src="../assets/img/m-icon-1.png" />
                <p>大赛奖励</p>
              </div>
              <div
                class="header-tabs-item"
                @click="
                  onJump(
                    'https://activity.simuwang.com/mobile/dist/competition/swhyjm-2021/index.html?channel=xsmtab=apply'
                  )
                "
              >
                <img src="../assets/img/m-icon-2.png" />
                <p>报名申请</p>
              </div>
              <div
                class="header-tabs-item"
                @click="handleActiveRouter('rank', '大赛排名')"
              >
                <img src="../assets/img/m-icon-3.png" />
                <p>大赛排名</p>
              </div>
            </div>
            <div class="header-tabs-csmar">
              <img
                src="../assets/img/m-csmar-server.png"
                alt=""
                @click="handleActiveRouter('csmar', '希施玛特色产品服务')"
              />
              <div class="header-tabs">
                <div
                  class="header-tabs-item"
                  @click="
                    onJump('http://testsite.csmar.com:5110/channels/36.html#quantifica')
                  "
                >
                  <img src="../assets/img/m-icon-5.png" />
                  <p>红楹量化数据库</p>
                </div>
                <div
                  class="header-tabs-item"
                  @click="onJump('http://testsite.csmar.com:5110/channels/36.html#level')"
                >
                  <img src="../assets/img/m-icon-6.png" />
                  <!-- <p>希施玛Level-2实时行情接口服务</p> -->
                  <p>Level-2实时行情接口</p>
                </div>
                <div
                  class="header-tabs-item"
                  @click="onJump('http://testsite.csmar.com:5110/channels/35.html')"
                >
                  <img src="../assets/img/m-icon-7.png" />
                  <p>红楹金融终端</p>
                </div>
                <div
                  class="header-tabs-item"
                  @click="onJump('http://testsite.csmar.com:5110/channels/37.html')"
                >
                  <img src="../assets/img/m-icon-8.png" />
                  <p>红楹金玛终端</p>
                </div>
              </div>
            </div>
          </div>
          <div class="front-content">
            <img src="../assets/img/m-1.png" />
            <img src="../assets/img/m-2.png" />
            <img src="../assets/img/m-3.png" />
            <img src="../assets/img/m-4.png" />
            <!-- <img src="../assets/img/m-5.png" />
            <div class="hot-list">
              <div class="swhy" @click="onJump('https://www.swhysc.com/swhysc/')"></div>
              <div class="csmar" @click="onJump('http://www.csmar.com/')"></div>
              <div class="lhhj" @click="onJump('https://www.hongkingsystem.cn/')"></div>
              <div class="ppw" @click="onJump('https://www.simuwang.com/')"></div>
            </div> -->
          </div>
        </div>
        <!-- 展示的页面 -->
        <div v-if="activeRouter">
          <div class="nav-header">
            <img src="../assets/img/back.png" alt="" @click="handleClose" />
            {{ headTitle }}
          </div>
          <div
            class="scroll-div"
            style="height: calc((100% - 1.1rem) - 0.88rem)"
          >
            <m-rule v-if="activeRouter === 'rule'" />
            <m-award v-if="activeRouter === 'award'" />
            <m-rank v-if="activeRouter === 'rank'" />
            <m-csmar v-if="activeRouter === 'csmar'" />
          </div>
        </div>
      </div>
    </div>
    <div class="join-in">
      <div class="btn or apply" @click="onJump('https://activity.simuwang.com/mobile/dist/competition/swhyjm-2021/index.html?channel=xsmtab=apply')">
        <img src="../assets/img/m-edit.png" alt="" class="or" />
        <span>立即报名</span>
      </div>
      <div class="btn or contact" @click="onContact">
        <img src="../assets/img/m-phone.png" alt="" class="or" />
        <span>联系我们</span>
      </div>
    </div>
    <!---->
    <transition name="fade">
      <div class="call" v-show="isContact">
        <div :class="['toast', isContact ? 'showToast':'hideToast']">
          <div class="title">是否拨打</div>
          <div class="sub-title">大赛组委会电话：021-33389692</div>
          <div class="btn-group">
            <div @click="onClose">否</div>
            <a href="tel:021-33389692" style="color: rgb(16, 142, 233)">是</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import mRule from "@/components/m-rule";
import mAward from "@/components/m-award";
import mRank from "@/components/m-rank";
import mCsmar from "@/components/m-csmar";
export default {
  inject: ["reload"],
  components: {
    mRule,
    mAward,
    mRank,
    mCsmar,
  },
  data() {
    return {
      activeRouter: "",
      headTitle: "",
      isContact: false
    };
  },
  methods: {
    onJump(url) {
      window.open(url);
    },
    handleActiveRouter(key, name) {
      this.activeRouter = key;
      this.headTitle = name;
    },
    handleClose() {
      this.reload();
      this.activeRouter = "";
      this.headTitle = "";
    },
    // 联系
    onContact() {
      this.isContact = true
    },
    onClose() {
      this.isContact = false
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../style/m-reset.css");
.swhyjm-2021-index {
  ::-webkit-scrollbar {
    display: none;
  } 
  font-family: "Source Han Sans CN";
  font-weight: 400;
  line-height: 1;
  color: #333;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  .nav-header {
    width: 100%;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    font-size: 0.36rem;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 100;
    img {
      position: absolute;
      top: calc(50% - 0.18rem);
      left: 0.3rem;
      width: 0.2rem;
      height: 0.36rem;
    }
  }
  
  .scroll-div {
    overflow: hidden;
    overflow-y: auto;
  }

  .swhyjm-2021-front {
    height: 100%;
    .front-header {
      background: #fff;
      img {
        width: 100%;
      }
      .header-tabs {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 0.35rem 0.3rem;
        padding-bottom: 0.5rem;
      }

      .header-tabs-item {
        // width: 0.96rem;
        width: 1.54rem;
        font-size: 0.24rem;
        line-height: 0.42rem;
        color: #333;
        text-align: center;
        img {
          width: 0.9rem;
        }
      }
      .header-tabs-csmar {
        margin: 0 0.3rem;
        margin-bottom: 0.35rem;
        border-radius: 17px;
        img {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        .header-tabs {
          margin-top: -0.04rem;
          padding: 0.35rem 0;
          padding-bottom: 0.15rem;
          background: #ecf7fe;
          border: 1px solid #7eb1ea;
          border-top: none;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
    .front-content {
      position: relative;
      background-color: #eee;
      img {
        width: 100%;
        margin-top: 0.2rem;
      }
      .hot-list {
        div{
          position: absolute;
          left: 0.8rem;
          bottom: 0;
          width: 5rem;
          height: 0.6rem;
        }
        .swhy {
          bottom: 5.9rem;
        }
        .csmar {
          bottom: 2.86rem;
        }
        .lhhj {
          bottom: 1.7rem;
        }
        .ppw {
          bottom: 0.66rem;
        }
      }
    }
  }
  .join-in {
    font-family: "Source Han Sans CN";
    font-weight: 400;
    line-height: 1;
    width: 100vw;
    height: 1.1rem;
    background: #fff;
    -webkit-box-shadow: 0rem -0.14rem 0.16rem 0.02rem rgb(216 216 216 / 25%);
    box-shadow: 0rem -0.14rem 0.16rem 0.02rem rgb(216 216 216 / 25%);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.11rem 0.32rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    .btn {
      font-size: 0.3rem;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      -ms-flex-item-align: stretch;
      align-self: stretch;
      border-radius: 0.2rem;
      color: #ffffff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      &.apply {
        background: #136bd7 !important;
      }
      &.contact {
        background: #eab32f;
      }
      img {
        width: 0.34rem;
        height: 0.34rem;
        margin-right: 0.2rem;
      }
      & + .btn {
        margin-left: 0.2rem;
      }
    }
  }
  .call {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background: rgba(60, 60, 60, 0.8);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    .toast {
      width: 5.4rem;
      height: 2.7rem;
      background: #fff;
      border-radius: 0.12rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 1;
      color: #010101;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      &.showToast {
        animation: show 1s 1;
        -webkit-animation: show 1s 1;
        animation-timing-function: ease-in-out;
        -webkit-animation: show 1s 1;
        -webkit-animation-timing-function: ease-in-out;
      }
      &.hideToast {
        animation: hide .45s 1;
        -webkit-animation: hide .45s 1;
        animation-timing-function: ease-in-out;
        -webkit-animation: hide .45s 1;
        -webkit-animation-timing-function: ease-in-out;
      }

      .title {
        margin-top: 0.42rem;
      }
      .btn-group {
        border-top: 1px solid #ddd;
        margin-top: 0.38rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        -ms-flex-item-align: stretch;
        align-self: stretch;
        & > * {
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
        }
        & > *:first-child {
          border-right: 1px solid #ddd;
        }
      }
      .title,
      .btn-group {
        font-size: 0.36rem;
      }
      .sub-title {
        margin-top: 0.3rem;
      }
    }
  }
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-to{
  opacity: 0;
}
.fade-leave-active{
  transition: opacity .45s;
}

@keyframes show {
  0% {
    transform: scale(2); 
     opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@-webkit-keyframes show {
  0% {
    transform: scale(2); 
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes hide {
  0% {
    transform: scale(1); 
     opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@-webkit-keyframes hide {
  0% {
    transform: scale(1); 
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>